module.exports = __webpack_public_path__ + "static/kanal-olustur-a8edda705eb3f8ebd742bf94bc7a9253.png";